/**
 * 약관 동의 이력 (/adm/terms/consent/logs) — 서비스·약관·결과·계기·회원·기간으로 동의 기록을 본다
 * ($j.Pages.Admin.ConsentLog / body data-page-name="ConsentLog")
 *
 * 약관 마스터 목록은 컨트롤러가 #page-data 로 넘긴다.
 */
export default class ConsentLog {
    initialize() { initialize(); }
}

let $logTable = null;
let SEARCH = {};

// 약관 마스터 전체 (num·code·name·service). 서비스 선택에 따라 약관 셀렉트를 다시 채운다.
let TERMS_LIST = [];

function initialize() {
    TERMS_LIST = JSON.parse(document.getElementById('page-data').textContent).termsList || [];

    $('#btnSearch').on('click', doSearch);
    $('#btnReset').on('click', resetSearch);
    // 약관명 → 그 회차 본문 미리보기
    $('#logTable').on('click', 'a[data-terms-ver]', function (e) {
        e.preventDefault();
        previewTerms(Number(this.dataset.termsVer));
    });

    initSearchBar();
    loadTable();
}

/**
 * 약관 셀렉트 채우기. 서비스가 선택돼 있으면 그 서비스의 약관만 남긴다.
 * 고르고 있던 약관이 새 목록에 없으면 '약관 전체' 로 돌아간다 — 화면에 안 보이는 항목이
 * 선택된 채로 남으면 결과가 왜 그런지 알 수 없다.
 */
function fillTermsSelect() {
    const svc  = $('#fService').val();
    const cur  = $('#fTerms').val();
    const list = svc ? TERMS_LIST.filter(t => t.service === svc) : TERMS_LIST;

    $('#fTerms').html(
        ['<option value="">약관 전체</option>']
            .concat(list.map(t => `<option value="${t.num}">${escHtml(t.name)}</option>`))
            .join('')
    );
    if (cur && list.some(t => String(t.num) === String(cur))) $('#fTerms').val(cur);
}

/** 검색바 — 회원 자동완성 · 달력 · 엔터검색 */
function initSearchBar() {
    fillTermsSelect();
    $('#fService').on('change', fillTermsSelect);

    // 회원 자동완성. 고르면 '이재일#2831' 이 인풋에 그대로 들어가고, 목록도 같은 표기로 그려
    // "고르면 무엇이 입력되는지" 가 미리 보이게 한다. (접수목록 /adm/orders 와 같은 규약)
    $j.F.Admin.AutoComplete.init({
        id: 'fMember', v: '', d: '',
        onSelect: function (id, $li) {
            $('#' + id).val(`${$li.data('name')}#${$li.data('num')}`);
            doSearch();
        },
        // 이름만 친 상태에서 포커스가 빠져도 번호로 바꾸지 않는다 — 이름검색도 유효한 상태다.
        onFind: function () {},
        // 목록에서 아무 항목도 고르지 않은 채 누른 엔터만 여기로 온다 (방향키 선택 중이면 선택이 우선)
        onEnter: function () { doSearch(); },
        onRender: function (row) {
            // 동명이인이 흔해 폰번호를 함께 보여준다
            const tpl = `<li class="ac-list-group-item" data-num="{num}" data-name="{mem_name}">{mem_name}#{num} <span class="cl-ac-phone">{mem_phone}</span></li>`;
            return $j.Common.Util.render_template(tpl, row);
        },
    });

    $('#fDateFrom, #fDateTo').mobiscroll().datepicker({
        controls: ['calendar'],
        dateFormat: 'YYYY-MM-DD',
        locale: mobiscroll.localeKo,
        buttons: [],
    });

    // 엔터로 바로 검색 (회원칸은 자동완성 onEnter 가 처리한다)
    $('.search-bar').on('keydown', 'input:not(#fMember), select', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); doSearch(); }
    });
}

function escHtml(s){ return String(s==null?'':s).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c])); }

/** 약관 동의 당시 버전 본문 미리보기 모달 */
function previewTerms(verNum) {
    $.post('/adm/ajax/terms/consent/preview', { ver_num: verNum }, function (res) {
        if (!res || !res.result) { alert('약관 본문을 불러오지 못했습니다.'); return; }
        const title = '약관 미리보기' + (res.version_no ? ' (v' + res.version_no + ')' : '');
        const body  = `<div class="cl-preview">${res.html || ''}</div>`;
        $j.Ui.JBModal.html('termsPreviewModal', body, title, { width: '900px' });
    }, 'json');
}

function doSearch() {
    SEARCH = {
        service: $('#fService').val(),
        terms_num: $('#fTerms').val(),
        consent_result: $('#fResult').val(),
        trigger_type: $('#fTrigger').val(),
        mb_kwd: $('#fMember').val(),
        date_from: $('#fDateFrom').val(),
        date_to: $('#fDateTo').val(),
    };
    $logTable.ajax.reload();
}

function resetSearch() {
    $('#fService, #fTerms, #fResult, #fTrigger').val('');
    $('#fMember, #fDateFrom, #fDateTo').val('');
    fillTermsSelect();
    SEARCH = {};
    $logTable.ajax.reload();
}

function loadTable() {
    if ($logTable) {
        $logTable.destroy();
        $('#logTable').empty();
    }

    $logTable = new DataTable('#logTable', {
        columns: [
            // 'No' 는 이력 PK(tcl.num)가 아니라 **화면 순번**이다.
            // 목록은 기록순 역순(ORDER BY tcl.num DESC)이라 번호도 전체건수에서 줄어든다
            // — 첫 행이 총건수, 마지막 행이 1.
            // serverSide 라 한 페이지치만 오므로 총건수는 응답의 recordsFiltered 를 쓴다.
            { data: 'num', title: 'No', width: '55px',
                render: function (v, t, r, meta) {
                    const s = meta.settings;
                    const total = s.json ? s.json.recordsFiltered : s.fnRecordsDisplay();
                    return total - s._iDisplayStart - meta.row;
                }
            },
            { data: 'consented_at', title: '일시', width: '140px', render: v => $j.Common.Util.formatDateTime(v) },
            { data: '_member', title: '회원', width: '150px',
                render: function (data, type, row) {
                    if (!row.mb_no) return data || '-';
                    return $j.F.Admin.Member.Pop.cell(row.mb_no, row.mem_name);
                }
            },
            { data: 'service', title: '서비스', width: '90px',
                render: function (data) {
                    // 필터 셀렉트(#fService)와 같은 표기를 쓴다
                    const map = { 'JB': '장비불러', 'BD': '악덕알리미', 'MC': '머큐리', 'IP': '이노페이' };
                    if (!data) return '-';
                    return `<span class="badge badge-service">${map[data] || escHtml(data)}</span>`;
                }
            },
            { data: 'terms_name', title: '약관 (버전)', width: '250px',
                render: function (data, type, row) {
                    const verTxt = row.version_no ? 'v' + row.version_no : '';
                    const label = escHtml(data || '-')
                        + (verTxt ? ` <span class="cl-ver">(${verTxt})</span>` : '');
                    if (!row.terms_ver_num) return label;
                    return `<a href="#" data-terms-ver="${row.terms_ver_num}">${label}</a>`;
                }
            },
            { data: '_consent', title: '결과', width: '60px',
                render: function (data, type, row) {
                    const cls = { '동의': 'badge-agree', '거부': 'badge-refuse', '철회': 'badge-withdraw' };
                    return `<span class="badge ${cls[data] || ''}">${data}</span>`;
                }
            },
            { data: 'trigger_type', title: '트리거', width: '110px',
                render: function (data) {
                    const map = {
                        'JOIN': '회원가입',
                        'SERVICE_JOIN': '서비스가입',
                        'REPORT_SUBMIT': '제보제출',
                        'CARD_MERCHANT': '카드가맹신청',
                        'SETTING_TOGGLE': '설정변경',
                        'ORDER_COMPLETE': '오더완료',
                        'MARKETING_POPUP': '마케팅팝업',
                        'AD_SMS_OPTOUT': '080 수신거부',
                        'RE_CONSENT': '재동의',
                        'LOCATION_GATE': '위치게이트',
                        'ADMIN_PROXY': '관리자 대리',
                        'LEGACY_ASSUME': '소급간주'
                    };
                    return `<span class="badge badge-trigger">${map[data] || data}</span>`;
                }
            },
            { data: 'device_type', title: '기기', width: '65px',
                render: function (data) {
                    return data ? `<span class="badge badge-device">${data}</span>` : '-';
                }
            },
            { data: 'ip_address', title: 'IP', width: '110px',
                render: function (data) {
                    return data || '-';
                }
            },
        ],
        ajax: {
            url: '/adm/ajax/terms/consent/logs',
            type: 'post',
            data: function (d) {
                Object.assign(d, SEARCH);
            }
        },
        columnDefs: [{ targets: '_all', className: 'text-center' }],
        processing: true,
        serverSide: true,
        ordering: false,
        searching: false,
        pageLength: 50,
        lengthChange: false,
        language: {
            emptyTable: '동의 이력이 없습니다.',
            zeroRecords: '일치하는 결과가 없습니다.',
            info: '총 _TOTAL_건 중 _START_ ~ _END_',
            paginate: { previous: '이전', next: '다음' },
        }
    });
}
